module.exports = __webpack_public_path__ + "img/vcard.4d38b3ed.png";